<template>
<div>
  <div class="label">{{ label }}</div>
  <span v-if="displayValue !== ''" class="value">{{ displayValue }}</span>
  <br v-else>
</div>
</template>

<style scoped>

</style>

<script>
import displayFormatterService from '@/services/shared/displayFormatterService.js';

export default {
  name: 'DisplayField',
  props: {
    label: {
      type: String,
      default: '',
      required: true
    },
    value: {
      type: [String, Number, Date, Boolean],
      default: '',
      required: true
    },
    type: {
      type: String,
      default: 'text'
    }
  },
  data: function () {
    return {
      displayValue: ''
    };
  },
  created: function () {
    if (this.value === null) {
      this.displayValue = '';
      return;
    }

    switch (this.type) {
      case 'date':
        this.displayValue = displayFormatterService.formatDate(this.value);
        break;
      case 'piiDate':
        this.displayValue = displayFormatterService.formatDayMonthDate(this.value);
        break;
      case 'currency':
        this.displayValue = displayFormatterService.formatCurrency(this.value);
        break;
      case 'number':
        this.displayValue = displayFormatterService.formatNumber(this.value);
        break;
      case 'bool':
        this.displayValue = displayFormatterService.formatBool(this.value);
        break;
      case 'sqft':
        this.displayValue = displayFormatterService.formatNumber(this.value) + ' sq ft';
        break;
      default:
        this.displayValue = this.value;
        break;
    }
  }
};
</script>
